import { render, staticRenderFns } from "./VoteAdminTemplate.vue?vue&type=template&id=c1a12690&"
import script from "./VoteAdminTemplate.vue?vue&type=script&lang=js&"
export * from "./VoteAdminTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports